<template>
  <w-icon-wrapper icon-name='work-business-trip-icon'>
    <path
      id='_63_Kfz-Strecke_Icon'
      d='M19,11H5A3,3,0,0,1,5,5H16.141a4,4,0,1,0,0-2H5A5,5,0,0,0,5,13H19a3,3,0,0,1,0,6H7.859a4,4,0,1,0,0,2H19a5,5,0,0,0,0-10Zm1-9a2,2,0,1,1-2,2A2,2,0,0,1,20,2ZM4,22a2,2,0,1,1,2-2A2,2,0,0,1,4,22Z'
      data-name='63 Kfz-Strecke_Icon'
      fill='currentColor'
    />
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconBusinessTrip' };
</script>
